// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'

import axios from 'axios'
import TTDError from '../utils/ttdError'
import { getSessionToken } from './auth'

/**
 *
 * @param {*} page
 * @param {*} search
 * @param {*} healthCareServiceId
 * @param {*} sort
 * @param {*} [filters=null]
 * @returns
 */
const getAllRequiredExperts = async (
    page: number,
    itemsPerPage: number,
    search: string,
    healthCareServiceId: string,
    sort: string,
    filters: object,
) => {
    const healthCareService = await ToktokdocLib.HealthCareService.findOne(healthCareServiceId)
    const finalUsers = await healthCareService.getPaginatedRequiredExperts(page, itemsPerPage, search, sort, filters)
    return new Promise((resolve, reject) => {
        try {
            resolve(finalUsers)
        } catch (error) {
            reject(error)
        }
    })
}

/**
 * Find a non existing user physician by RPPS
 * true if already exist false if unknow rpps or value
 * @param {string} rpps
 */
const findPhysicianByRpps = async (rpps: string): Promise<boolean | string> => {
    const token = await ToktokdocLib.Utils.getSessionToken()
    const res = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/user/national_id/${rpps}`, {
        headers: {
            'X-Session-Token': token,
        },
    })

    return res.data
}

/**
 * Get user sensitive data from parse
 * @param {String} userId objectId
 */
const getUserSensitiveData = async (userId: any, hidden = false) => {
    const ttdError = new TTDError("impossible de récupérer les données de l'utilisateur", true)

    try {
        const token = await getSessionToken()
        const response = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/login/getSensitiveData/${userId}`, {
            headers: {
                'X-Session-Token': token,
            },
        })
        if (response.status === 200 && response.data.email.length > 0) {
            const { securedEmail } = response.data
            let { email, privatePhone } = response.data

            if (hidden) {
                const emailData = email.split('@')
                email = `${emailData[0]}@${emailData[1].replaceAll(/[^.]/g, '*')}`
                privatePhone = privatePhone.substr(0, 5) + privatePhone.substr(5).replaceAll(/[\d]/g, '*')
            }

            return {
                email,
                privatePhone,
                securedEmail,
            }
        }

        throw ttdError
    } catch (error) {
        throw ttdError
    }
}

const forceUserPassword = async (hcsId: any, userId: any, password: any) => {
    const token = await getSessionToken()
    const body = {
        userId,
        password,
    }
    try {
        const result = await axios.post(`${window._env_.REACT_APP_HDS_HOST}/user/forcePassword/${hcsId}`, body, {
            headers: {
                'X-Session-Token': token,
            },
        })
        return result
    } catch (error) {
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        if (error.response.data.error.code === 142) {
            throw new Error('Vous ne pouvez pas utiliser les précédents mots de passe de cet utilisateur.')
        }
        throw new Error('Impossible de mettre à jour le mot de passe.')
    }
}

export { findPhysicianByRpps, forceUserPassword, getAllRequiredExperts, getUserSensitiveData }
